import { render, staticRenderFns } from "./MessageContent.vue?vue&type=template&id=32228a28&scoped=true&"
import script from "./MessageContent.vue?vue&type=script&lang=ts&"
export * from "./MessageContent.vue?vue&type=script&lang=ts&"
import style0 from "./MessageContent.vue?vue&type=style&index=0&id=32228a28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32228a28",
  null
  
)

export default component.exports